import { render, staticRenderFns } from "./RetiradosPage.vue?vue&type=template&id=357c8e10&"
import script from "./RetiradosPage.vue?vue&type=script&lang=js&"
export * from "./RetiradosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports